import React, { useRef, useState } from 'react';
import { Upload, X, ImagePlus } from 'lucide-react';
import '../../assets/css/productinfo.css';

import DesignOverlay from '../design/DesignOverlay';
import CartPanel from '../cart/CartPanel';

const ProductInfoTab = ({
  productName = 'Custom Product',
  currentViews = {},
  placementList = [],
  placementTexts = {},
  placementImages = {},
  methodPositions = {},

  selectedColors,
  setSelectedColors,
  sizes,
  setSizes,

  cartOptions,
  setCartOptions,

  colorOptions,
  pricePerUnit,
  basePrice,
  designExtraFeePerUnit,

  referenceImage,
  setReferenceImage,

  note,
  setNote,
  onAddToCart
}) => {
  const fileInputRef = useRef(null);

  // NEW: which thumbnail is currently shown in the big preview card
  const [activeView, setActiveView] = useState('front');

  const handleReferenceFile = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setReferenceImage({
        name: file.name,
        dataUrl: String(reader.result || ''),
      });
    };
    reader.readAsDataURL(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    handleReferenceFile(file);
  };

  const activeFrontView = (() => {
    const selectedHex = Array.isArray(selectedColors) ? selectedColors[0] : selectedColors;
    const match = (colorOptions || []).find((c) => c.hex === selectedHex);
    return match?.image ? match.image : currentViews.front;
  })();

  // NEW: resolves the correct image for whichever view is active.
  // 'front' still respects the selected color swap; other views fall
  // back to whatever currentViews has for that angle.
  const resolveViewImage = (viewKey) => {
    if (viewKey === 'front') return activeFrontView;
    return currentViews?.[viewKey] || activeFrontView;
  };

  const activeCartColorHex = (() => {
    const selectedHex = Array.isArray(selectedColors) ? selectedColors[0] : selectedColors;
    return selectedHex || colorOptions?.[0]?.hex || '#000000';
  })();

  return (
    <div className="product-info-tab">
      <div className="product-info-main">
        <div className="product-info-preview-area">
          <div className="preview-thumbnail-list">
            {['front', 'back', 'left', 'right'].map((viewKey) => (
              <div
                key={viewKey}
                className={`preview-thumbnail-item${activeView === viewKey ? ' active' : ''}`}
                onClick={() => setActiveView(viewKey)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') setActiveView(viewKey);
                }}
              >
                <div className="preview-thumbnail-image">
                  <img
                    src={currentViews?.[viewKey] || activeFrontView}
                    alt={viewKey}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="product-info-image-card">
            <img src={resolveViewImage(activeView)} alt={activeView} />
            <DesignOverlay
              activeView={activeView}
              placementList={placementList}
              placementTexts={placementTexts}
              placementImages={placementImages}
              methodPositions={methodPositions}
            />
          </div>
        </div>
      </div>

      <CartPanel
        productImage={activeFrontView}
        productName={productName}
        baseColor={activeCartColorHex}
        setBaseColor={setSelectedColors}
        baseSizes={sizes}
        setBaseSizes={setSizes}
        extraOptions={cartOptions}
        setExtraOptions={setCartOptions}
        colors={colorOptions}
        pricePerUnit={pricePerUnit}
        basePrice={basePrice}
        designExtraFeePerUnit={designExtraFeePerUnit}
        note={note}
        setNote={setNote}
        selectedColorHex={activeCartColorHex}
        onSelectedColorHexChange={(hex) => setSelectedColors([hex])}
        onAddToCart={onAddToCart}
      />
    </div>
  );
};

export default ProductInfoTab;